import { useAuth } from '@/core/contexts/AuthContext';
import { logger } from '@/core/logger';
// @ts-ignore Dynatrace service is ts-nocheck; runtime export is available
import { trackDynatraceEvent } from '@/core/services/dynatraceService';
import { resolveAdhaPostLoginDeepLink } from '@/modules/properties-web/utils/adhaDeepLinkRedirect';
import { router, type Href } from 'expo-router';
import { useEffect, useRef } from 'react';

/**
 * Welcome (web): redirect authenticated users to home.
 * Page view: legacy `Welcome Page Viewed` (below).
 */
export function useWelcomeWebAuthRedirect(): void {
  const { isAuthenticated, isLoading: authLoading } = useAuth();
  const hasNavigatedRef = useRef(false);

  useEffect(() => {
    trackDynatraceEvent({
      p_screen: 'welcome',
      p_actionName: 'Welcome Page Viewed',
      eventType: 'view',
    });
  }, []);

  useEffect(() => {
    if (hasNavigatedRef.current) {
      return;
    }

    if (authLoading || !isAuthenticated) {
      return;
    }

    const deepLink = resolveAdhaPostLoginDeepLink();
    logger.info('WelcomeWeb', 'User already authenticated, redirecting', {
      target: deepLink ?? 'home',
    });
    hasNavigatedRef.current = true;
    try {
      if (router.canGoBack()) {
        router.dismissAll();
      }
    } catch (error) {
      logger.debug('WelcomeWeb', 'dismissAll failed, using replace only', error);
    }
    router.replace((deepLink ?? '/(auth)/(home)') as Href);
  }, [authLoading, isAuthenticated]);
}
